import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

interface CardSkeletonProps {
  className?: string;
}

export default function CardSkeleton (props: CardSkeletonProps) {
  const { className } = props

  return (
    <SkeletonTheme>
      <div className={className}>
        <Skeleton
          width={'100%'}
          style={{
            borderRadius: 24,
            marginBottom: 8,
            aspectRatio: '1/1',
          }}
        />
        <div
          style={{
            padding: '8px 16px',
          }}
        >
          <Skeleton
            width={'55%'}
            height={27}
            style={{
              borderRadius: 8,
              marginBottom: 8,
            }}
          />
          <Skeleton
            width={'77%'}
            height={16}
            style={{
              borderRadius: 6,
              marginBottom: 6,
            }}
          />
          <Skeleton
            width={'57%'}
            height={16}
            style={{
              borderRadius: 6,
              marginBottom: 27,
            }}
          />
          <Skeleton
            width={'100%'}
            height={48}
            style={{
              borderRadius: 12,
            }}
          />
        </div>
      </div>
    </SkeletonTheme>
  )
}
